module.exports = __webpack_public_path__ + "0d1ed4e57389f825111dfc94fdc1e9ad.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots/eagle_owl_hoot.mp3
// module id = 3880
// module chunks = 0